import { Bank_status } from 'hooks/webapi/useBanks';
import Cookies from 'js-cookie';

const UNNAX_ATTEMPTS_COOKIE = 'unnax_attempts';
export const UNNAX_MAX_ATTEMPTS = 3;

export const isUnnaxStatusSuccess = (status: Bank_status | undefined) =>
  ['SUCCESS', 'SUCCESS_SAME_IBAN_SELECTED'].includes(status || '');

export const setCookieUnnaxAttempts = (attempts: number) => {
  // Create a date that is 7 days from now
  const endWeek = new Date();
  endWeek.setDate(endWeek.getDate() + 7);

  // Set cookie to expire in 7 days
  Cookies.set(UNNAX_ATTEMPTS_COOKIE, String(attempts), { expires: endWeek });
};

export const getCookieUnnaxAttempts = () => {
  return Number(Cookies.get(UNNAX_ATTEMPTS_COOKIE) || '0');
};

export const removeCookieUnnaxAttempts = () => {
  Cookies.remove(UNNAX_ATTEMPTS_COOKIE);
};
